export default "__VITE_ASSET__ByfDuwaQ__"